import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewsletterComponent, NewsletterBubbleComponent, NewsletterV2Component } from './components';
import { MmButtonModule, MmFlexLayoutModule, MmIconModule, MmFormFieldModule } from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { ProductCardModule } from '~shared/modules/product-card/product-card.module';
import { IsVisibleModule } from '~shared/directives/is-visible/is-visible.module';
import { LazyLoadImageModule } from '~shared/directives/lazyload/lazy-load-image.module';
import { SanitizeModule } from '~shared/pipes/sanitaze/sanitaze.module';

@NgModule({
  declarations: [NewsletterComponent, NewsletterV2Component, NewsletterBubbleComponent],
  imports: [
    CommonModule,
    MmFlexLayoutModule,
    MmButtonModule,
    MmIconModule,
    MmFormFieldModule,
    QaLocatorsModule,
    TranslateModule,
    ProductCardModule,
    IsVisibleModule,
    FormsModule,
    ReactiveFormsModule,
    LazyLoadImageModule,
    SanitizeModule,
  ],
  exports: [NewsletterComponent, NewsletterV2Component, NewsletterBubbleComponent],
})
export class NewsletterSubscriptionModule {}
